module.exports = __webpack_public_path__ + "img/img03.7dd54bfd.jpg";